// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1t0Hz","content":"styles_content__22HpD","selectAll":"styles_selectAll__3UlUd"};